import borderMutations from '@constans/store/border/borderMutations';
const mutations = {
    [borderMutations.SET_BORDERS]: (state, borders) => state.borders = borders,
    [borderMutations.SET_PARENT_ID]: (state, parentId) => state.parentId = parentId,
    [borderMutations.CHANGE_STATE]: (state, field) => {
        Object.keys(field).forEach(key => {
            const currentState = field.base !== undefined ? state[field.base] : state;
            // Do not save the "key base" in state.
            if (key !== 'base') {
                currentState[key] = field[key];
            }
        });
    },
};
export default mutations;
